<template>
    <div
        :class="['extra-item', { className: className }]"
        @click="selectItem"
    >
        <img
            :src="icons[icon]"
            :alt="name"
        />
        <p>
            {{ title }}
        </p>
        <new-checkbox
            v-model="form[stepName][name]"
            :noLabel="true"
        />
    </div>
</template>

<script>
import flight from "../../../../../images/extra-coverage/extra-flight.svg";
import car from "../../../../../images/extra-coverage/extra-car.svg";
import phone from "../../../../../images/extra-coverage/extra-phone.svg";
import laptop from "../../../../../images/extra-coverage/extra-laptop.svg";
import luggage from "../../../../../images/extra-coverage/extra-luggage.svg";
import equipment from "../../../../../images/extra-coverage/extra-equipment.svg";
import third_party from "../../../../../images/extra-coverage/extra-third-party.svg";
import search_and_rescue from "../../../../../images/extra-coverage/extra-search-and-rescue.svg";
import winter from "../../../../../images/extra-coverage/noun-winter-sport-3456176.svg";
import NewCheckbox from "../../../Forms/NewCheckbox.vue";
export default {
    props: {
        title: {
            type: String
        },
        icon: {
            type: String
        },
        name: {
            type: String
        },
        form: [Object],
        stepName: {
            type: String
        },
        className: {
            type: String
        }
    },
    components: { NewCheckbox },
    data() {
        return {
            icons: {
                flight,
                car,
                phone,
                laptop,
                luggage,
                equipment,
                third_party,
                search_and_rescue,
                winter
            }
        };
    },
    methods: {
        selectItem() {
            this.form[this.stepName][this.name] = !this.form[this.stepName][
                this.name
            ];
        }
    }
};
</script>

<style lang="scss" scoped>
p {
    @media all and (max-width: $mobile) {
       font-size: small;
    }
}
.extra-item {
    display: grid;
    grid-template-columns: 100%;
    grid-template-rows: 50% 30% 20%;
    align-items: center;
    justify-items: center;
    gap: 10px;
    background-color: #fbfbfb;
    border-radius: 5px;
    border: 1px solid rgba($color: #214392, $alpha: 0.2);
    padding: 20px 30px;
    width: 240px;
    height: 240px;
    text-align: center;
    cursor: pointer;

    @media all and (max-width: $mobile) {
        width: 160px;
        height: 160px;
    }

    ::v-deep {
        .app-checkbox {
            display: flex;
            justify-content: center;
            align-items: center;

            .control {
                margin: unset;

                .graphics {
                    border: 1px solid #cfd6e6;
                    border-radius: 4px;
                }
            }
        }
    }

    .no-gap {
        gap: 0;
    }
}
</style>
